/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerOnlinePaymentsResponse as ModelsCustomerCustomerOnlinePaymentsResponse } from '../../models/Models/Customer/customer-online-payments-response';

export interface V4CustomersMeOnlinePaymentsGet$Json$Params {
  dateFrom?: string;
  dateTo?: string;
  reference?: string;
  pageNumber?: number;
  pageSize?: number;
}

export function v4CustomersMeOnlinePaymentsGet$Json(http: HttpClient, rootUrl: string, params?: V4CustomersMeOnlinePaymentsGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentsResponse>> {
  const rb = new RequestBuilder(rootUrl, v4CustomersMeOnlinePaymentsGet$Json.PATH, 'get');
  if (params) {
    rb.query('dateFrom', params.dateFrom, {});
    rb.query('dateTo', params.dateTo, {});
    rb.query('reference', params.reference, {});
    rb.query('pageNumber', params.pageNumber, {});
    rb.query('pageSize', params.pageSize, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentsResponse>;
    })
  );
}

v4CustomersMeOnlinePaymentsGet$Json.PATH = '/v4/customers/me/online-payments';
